<template>
  <v-container ref="printReport" fluid class="white lighten-5 pa-7">
    <v-tabs v-model="tab" color="black" background-color="transparent" grow>
      <v-tab> Vínculos </v-tab>
      <v-tab> Políticas </v-tab>
    </v-tabs>
    <div class="mt-2">
      <v-tabs-items v-model="tab">
        <v-tab-item>
          <link-boxes />
        </v-tab-item>
        <v-tab-item>
          <policy-boxes :user-channel="userChannel" />
        </v-tab-item>
      </v-tabs-items>
    </div>
  </v-container>
</template>

<script>
  import LinkBoxes from './components/LinkBoxes.vue';
  import PolicyBoxes from './components/PolicyBoxes.vue';

  export default {
    name: 'Vinculos',
    components: {
      LinkBoxes,
      PolicyBoxes,
    },

    data() {
      return {
        tab: 0,
      };
    },
  };
</script>
